import React, { useState } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { ChevronDown } from 'lucide-react';

const Header = ({ language, onLanguageChange }) => {
  const texts = {
    en: {
      logo: '365FullPull',
      nav: ['Home', 'Features', 'How it works', 'Games'],
      terms: 'Terms and Conditions'
    },
    sl: {
      logo: '365FullPull',
      nav: ['Domov', 'Funkcije', 'Kako deluje', 'Igre'],
      terms: 'Splošna določila in pogoji'
    }
  };

  const t = texts[language];
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const languages = [
    { code: 'en', name: 'English', flag: 'GB' },
    { code: 'sl', name: 'Slovenščina', flag: 'SI' }
  ];

  const handleLanguageSelect = (langCode) => {
    onLanguageChange(langCode);
    setDropdownOpen(false);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-blue-600">{t.logo}</h1>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            {t.nav.map((item, index) => (
              <a
                key={index}
                href={`#section-${index + 1}`}
                className="text-gray-700 hover:text-blue-600 transition-colors duration-200"
              >
                {item}
              </a>
            ))}
            <a
              href="/terms.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200"
            >
              {t.terms}
            </a>
          </nav>

          <div className="flex items-center space-x-4">
            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
              >
                <ReactCountryFlag 
                  countryCode={languages.find(l => l.code === language)?.flag || 'GB'} 
                  svg 
                  className="w-6 h-4" 
                />
                <span className="text-sm font-medium">
                  {languages.find(l => l.code === language)?.name}
                </span>
                <ChevronDown className="w-4 h-4" />
              </button>
              
              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      onClick={() => handleLanguageSelect(lang.code)}
                      className={`w-full flex items-center space-x-3 px-4 py-2 text-left hover:bg-gray-100 transition-colors ${
                        language === lang.code ? 'bg-blue-50' : ''
                      }`}
                    >
                      <ReactCountryFlag 
                        countryCode={lang.flag} 
                        svg 
                        className="w-6 h-4" 
                      />
                      <span className="text-sm font-medium">{lang.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {dropdownOpen && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setDropdownOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;
